import { put, call, all, takeLatest } from 'redux-saga/effects';
import { merge, get, clone, set } from 'lodash';
import { ACTIONBASEINFO, ACITONCOPYRIGHT } from '../../../actionTypes';
import { APIUSER, APICOMMON, APICOPYRIGHT } from '../../../actionApi';
import { request } from '../../../utils/request';
import { API } from '../../../env';
function* getCityList(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOMMON.CITY,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		yield put({ type: ACTIONBASEINFO.SET_BASEINFO_CITYLIST, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
// function* getBaseInfo(data) {
// 	let { payload, callback, errorCallback } = data;
// 	let res = yield call(request, {
// 		type: 'GET',
// 		url: API.COMMON_PORXY + APICOMMON.BASEINFODETIAL,
// 		dataParam: payload || {}
// 	});
// 	let { ok, status, result = {} } = res || {};
// 	console.log ( "user..." , result)
// 	if (status === 200) {
// 		yield put({ type: ACTIONBASEINFO.SET_COPYRIGHT_BASEINFO, payload: result });
// 		return callback && callback(result);
// 	}
// 	return errorCallback && errorCallback(result);
// }
// function* setBaseInfo(data) {
// 	let { payload, callback, errorCallback } = data;
// 	let newpayload = clone(payload);
// 	if (get(newpayload, 'companyLogo', '')) {
// 		delete newpayload['companyLogo'];
// 	}
// 	let res = yield call(request, {
// 		type: 'PUT',
// 		url: API.COMMON_PORXY + APICOMMON.BASEINFODETIAL,
// 		dataParam: newpayload || {}
// 	});
// 	let { ok, status, result = {} } = res || {};
// 	if (status === 200) {
// 		console.log('newpayload...', newpayload);
// 		yield put({ type: ACTIONBASEINFO.SET_BASEINFO_DETAIL, payload: payload });
// 		return callback && callback(payload, result);
// 	}
// 	return errorCallback && errorCallback(result);
// }
function* getUserInfo(data) {
	let { payload, callback, errorCallback } = data;
	console.log(payload);
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOPYRIGHT.USERINFO,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		yield put({ type: ACITONCOPYRIGHT.SET_COPYRIGHT_BASEINFO, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* saveBaseInfoHead(data) {
	console.log('come ..........', data);
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'POST',
		url: API.COMMON_PORXY + APICOPYRIGHT.UPLOADAVATAR,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		console.log('newpayload...', result);
		yield put({ type: ACITONCOPYRIGHT.SET_COPYRIGHT_BASEINFO, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* saveGalleryImgPraise(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'POST',
		url: API.COMMON_PORXY + APICOPYRIGHT.GALLERYIMGPRAISE,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		let { name, index, operation } = payload;
		console.log('payload...', payload);
		if (name === 'praise') {
			yield put({ type: ACITONCOPYRIGHT.SET_GALLERYIMG_PRAISE, payload: { index, operation } });
		} else if (name === 'gallery') {
			yield put({ type: ACITONCOPYRIGHT.SET_GALLERYIMG_GALLERY, payload: { index, operation } });
		} else if (name === 'activity') {
			yield put({ type: ACITONCOPYRIGHT.SET_GALLERYIMG_ACITIVIY, payload: { index, operation } });
		} else if (name === 'home') {
			yield put({ type: ACITONCOPYRIGHT.SET_GALLERYIMG_HOME, payload: { index, operation } });
		} else if (name === 'search') {
			yield put({ type: ACITONCOPYRIGHT.SET_GALLERYIMG_SEARCH, payload: { index, operation } });
		}
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* searchToutu(data) {
	console.log('search toutu ..........', data);
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'POST',
		url: API.COMMON_PORXY + APICOPYRIGHT.SEARCHTOUTU,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		console.log('newpayload...', result);
		yield put({ type: ACITONCOPYRIGHT.SET_SEARCH_TOUTUINFO, payload: { result, searchType: payload.type, tag: payload.tag } });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* getTopicConfigList(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOPYRIGHT.TOPICCONFIGLIST,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		console.log('newpayload...。。。。。', result);
		yield put({ type: ACITONCOPYRIGHT.SET_TOPICCONIFG_LIST, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* getBannerConfigList(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOPYRIGHT.BANNERCONFIGLIST,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		console.log('newpayload...。。。。。', result);
		yield put({ type: ACITONCOPYRIGHT.SET_BANNERCONIFG_LIST, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* getActivityConfigList(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOPYRIGHT.ACTIVITYCONFIGLIST,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		console.log('newpayload...。。。。。', result);
		yield put({ type: ACITONCOPYRIGHT.SET_ACTIVITYCONIFG_LIST, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* getWeixinConfig(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOPYRIGHT.WEIXINCONFIG,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* getWeixinToken(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'POST',
		url: API.COMMON_PORXY + APICOPYRIGHT.WEIXINTOKEN,
		dataParam: payload || {},
		contentType: 'multipart/form-data'
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}

let copyrightBaseinfoSaga = [
	takeLatest(ACTIONBASEINFO.FETCH_BASEINFO_CITYLIST, getCityList),
	takeLatest(ACITONCOPYRIGHT.FETCH_USER_INFO, getUserInfo),
	takeLatest(ACITONCOPYRIGHT.FETCH_COPYRIGHTHEAD_IMG, saveBaseInfoHead),
	takeLatest(ACITONCOPYRIGHT.FETCH_GALLERYIMG_PRAISE, saveGalleryImgPraise),
	takeLatest(ACITONCOPYRIGHT.FETCH_SEARCH_TOUTUINFO, searchToutu),
	takeLatest(ACITONCOPYRIGHT.FETCH_TOPICCONFIG_LIST, getTopicConfigList),
	takeLatest(ACITONCOPYRIGHT.FETCH_BANNERCONFIG_LIST, getBannerConfigList),
	takeLatest(ACITONCOPYRIGHT.FETCH_ACTIVITYCONFIG_LIST, getActivityConfigList),
	takeLatest(ACTIONBASEINFO.FETCH_BASEINFO_WEIXINCONFIG, getWeixinConfig),
	takeLatest(ACTIONBASEINFO.FETCH_BASEINFO_WECHATTOKEN, getWeixinToken)
];
export { copyrightBaseinfoSaga };
